"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ContactActionsContext = require("./ContactActionsContext");
Object.keys(_ContactActionsContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ContactActionsContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ContactActionsContext[key];
    }
  });
});